// @flow strict

/**
 * Actions
 *
 * Define constant types for each action
 * For each type, define action to pass data/errors as payload
 */

import type { Reagent, ReagentQueryType } from 'services/Reagent/types';
import type { ErrorType } from 'types';

export const CREATE_SUCCESS = 'app/services/Reagent/CREATE_SUCCESS';
export const CREATE_FAILURE = 'app/services/Reagent/CREATE_FAILURE';
export const FETCH_LIST_SUCCESS = 'app/services/Reagent/FETCH_LIST_SUCCESS';
export const FETCH_LIST_FAILURE = 'app/services/Reagent/FETCH_LIST_FAILURE';
export const UPDATE_SUCCESS = 'app/services/Reagent/UPDATE_SUCCESS';
export const UPDATE_FAILURE = 'app/services/Reagent/UPDATE_FAILURE';
export const DESTROY_SUCCESS = 'app/services/Reagent/DESTROY_SUCCESS';
export const DESTROY_FAILURE = 'app/services/Reagent/DESTROY_FAILURE';
export const QUERY_LIST_SUCCESS = 'app/services/Reagents/QUERY_LIST_SUCCESS';
export const QUERY_LIST_FAILURE = 'app/services/Reagents/QUERY_LIST_FAILURE';
export const IS_FETCHING = 'app/services/Reagent/IS_FETCHING';
export const IS_UPDATING = 'app/services/Reagent/IS_UPDATING';
export const IS_DELETING = 'app/services/Reagent/IS_DELETING';
export const IS_CREATING = 'app/services/Reagent/IS_CREATING';
export const IS_QUERYING = 'app/services/Reagent/IS_QUERYING';

export const SET_PLANT_ACCESS_SUCCESS = 'app/services/Reagents/SET_PLANT_ACCESS_SUCCESS';
export const SET_PLANT_ACCESS_FAILURE = 'app/services/Reagents/SET_PLANT_ACCESS_FAILURE';
export const IS_SETTING_PLANT_ACCESS = 'app/services/Reagent/IS_SETTING_PLANT_ACCESS';

export const receivedCreateSuccess = (data: Reagent) => ({
    type: CREATE_SUCCESS,
    payload: { data },
});

export const receivedCreateFailure = (errors: {}) => ({
    type: CREATE_FAILURE,
    payload: { errors },
});

export const receivedFetchListSuccess = (data: Array<Reagent>) => ({
    type: FETCH_LIST_SUCCESS,
    payload: { data },
});

export const receivedFetchListFailure = (errors: {}) => ({
    type: FETCH_LIST_FAILURE,
    payload: { errors },
});

export const receivedUpdateSuccess = (data: Reagent) => ({
    type: UPDATE_SUCCESS,
    payload: { data },
});

export const receivedUpdateFailure = (errors: {}) => ({
    type: UPDATE_FAILURE,
    payload: { errors },
});

export const receivedDestroySuccess = (data: Reagent) => ({
    type: DESTROY_SUCCESS,
    payload: { data },
});

export const receivedDestroyFailure = (errors: {}) => ({
    type: DESTROY_FAILURE,
    payload: { errors },
});

export const receivedQueryListSuccess = (data: ReagentQueryType) => ({
    type: QUERY_LIST_SUCCESS,
    payload: { data },
});

export const receivedQueryListFailure = (errors: {}) => ({
    type: QUERY_LIST_FAILURE,
    payload: { errors },
});

export const setIsFetchingStatus = (isFetching: boolean = true) => ({
    type: IS_FETCHING,
    payload: { isFetching },
});

export const setIsUpdatingStatus = (isUpdating: boolean = true) => ({
    type: IS_UPDATING,
    payload: { isUpdating },
});

export const setIsDeletingStatus = (isDeleting: boolean = true) => ({
    type: IS_DELETING,
    payload: { isDeleting },
});

export const setIsCreatingStatus = (isCreating: boolean = true) => ({
    type: IS_CREATING,
    payload: { isCreating },
});

export const setIsQueryStatus = (isQuerying: boolean = true) => ({
    type: IS_QUERYING,
    payload: { isQuerying },
});

export const setIsSettingReagentPlantAccessStatus = (isSettingPlantAccess: boolean = true) => ({
    type: IS_SETTING_PLANT_ACCESS,
    payload: { isSettingPlantAccess },
});

export const receivedSetReagentPlantAccessSuccess = (data: Reagent) => ({
    type: SET_PLANT_ACCESS_SUCCESS,
    payload: { data },
});

export const receivedSetReagentPlantAccessFailure = (errors: ErrorType) => ({
    type: SET_PLANT_ACCESS_FAILURE,
    payload: { errors },
});
